import { todayStr } from "../domain/date";
import type { KayaState } from "../domain/types";
import { WATER_DEFAULTS } from "../domain/water";

/** The original PWA's defaults, unchanged. */
export function defaultState(): KayaState {
  return {
    profile: {
      name: "",
      heightCm: 173,
      startWeight: 80,
      goal: "weight",
      targetWeight: 72,
      targetWaist: 0,
      stepGoal: 8000,
      kcalGoal: 400,
      moveMinGoal: 30,
      startDate: todayStr(),
      phaseMode: "auto",
      hipSafe: true,
      brisk: 6.5,
      easy: 4.5,
      brisk1: 6.2,
      easy1: 4.5,
      incline: 0,
      sound: true,
      vibrate: true,
      notify: false,
      restMove: 0,
      restRound: 0,
      prepSecs: 10,
      sex: "",
      cycleOn: false,
      periodsStopped: false,
      irregular: false,
      theme: "system",
      remindOn: false,
      remindMorning: "07:00",
      remindEvening: "19:00",
      notifyWanted: false,
      phoneOnBodyDefault: false,
      water: { ...WATER_DEFAULTS, bottles: [] },
    },
    logs: {},
    measures: [],
    travelDates: {},
    travelAt: {},
    travelOff: {},
    overrides: {},
    overridesAt: {},
    overridesOff: {},
    installed: false,
    badges: {},
    freezes: 1,
    freezeEarned: {},
    challenges: {},
    rescueFor: null,
    recapSeen: {},
    cycle: { starts: [], length: 28, periodLen: 5, startsAt: {}, startsOff: {} },
    customFoods: [],
  };
}

/** Deep-ish merge used on load so a state blob written by an older build gains new fields. */
export function hydrate(raw: Partial<KayaState> | null | undefined): KayaState {
  const d = defaultState();
  if (!raw) return d;
  return {
    ...d,
    ...raw,
    profile: {
      ...d.profile,
      ...(raw.profile || {}),
      // a block written by an older build gains the fields added since, unstamped (ADR-044)
      water: { ...WATER_DEFAULTS, ...(raw.profile?.water || {}), bottles: raw.profile?.water?.bottles || [] },
    },
    cycle: { ...d.cycle, ...(raw.cycle || {}) },
    customFoods: raw.customFoods || [],
  };
}
